import React, { useContext, useEffect, useRef } from 'react';

import { HeaderServiceManager } from '../../../serviceContextManager/layout/HeaderServiceManager';

import { RightMenuComponent } from '../../../components/RightMenuComponent';
import { LayoutContext } from '../../../context/LayoutContext';
import { validatePermissions } from '../../../utils/utils';

interface IMainContainer {
  children?: any;
  rightMenuContent?: any;
  openRightMenu?: boolean;
  setOpenRightMenu?: any;
  loading: boolean;
}
export const MainContainer = (props: IMainContainer) => {
  const {
    children,
    rightMenuContent,
    openRightMenu,
    setOpenRightMenu,
    loading = false,
  } = props;
  const { permitUrl } = useContext(HeaderServiceManager);

  const rightMenuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      if (
        rightMenuRef.current &&
        !rightMenuRef.current.contains(event.target as Node) &&
        !document.querySelector('.p-dropdown-panel')?.contains(target) &&
        !document.querySelector('.p-multiselect-panel')?.contains(target) &&
        !document.querySelector('.p-dialog-mask')?.contains(target) &&
        !document.querySelector('.p-datepicker')?.contains(target) &&
        !document.querySelector('.p-multiselect-item')?.contains(target) &&
        !document.querySelector('.p-dropdown-item')?.contains(target) &&
        !document.querySelector('.p-checkbox-box')?.contains(target) &&
        !document.querySelector('.p-checkbox-icon')?.contains(target) &&
        !document.querySelector('.Toastify')?.contains(target)
      ) {
        setOpenRightMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (
    <div className="flex w-full h-full relative overflow-hidden">
      {/* Contenido principal */}
      <div className="flex-1 h-full overflow-auto">
        {validatePermissions(permitUrl) ? (
          children
        ) : (
          <div className="flex flex-col items-center justify-center w-full h-full">
            <span className="bold text-xl">
              No cuenta con los permisos para ver esta página, consulte con su
              administrador.
            </span>
          </div>
        )}
      </div>

      {/* Menú lateral derecho (superpuesto) */}
      {openRightMenu && (
        <div className="absolute top-0 right-0 h-full z-40">
          <RightMenuComponent
            rightMenuRef={rightMenuRef}
            setOpenRightMenu={setOpenRightMenu}
            loading={loading}>
            {rightMenuContent()}
          </RightMenuComponent>
        </div>
      )}
    </div>
  );
};
